import React, { useState } from "react";
import { useSessionContext } from "supertokens-auth-react/recipe/session";

import { debounceTextClassNameSmall } from "../../../helpers/debounceTextClassName";
import { getHighlightTextParts } from "./helpers/highlightText";

import { useGetReminderCommentsQuery } from "../../api/moduleAPI";

import { Col, Container, InputGroup, Row } from "react-bootstrap";
import { Hint } from "@progress/kendo-react-labels";

import { Dialog } from "@progress/kendo-react-dialogs";
import { TextArea } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import ReactTimeAgo from "react-time-ago";

import { DebounceInput } from "react-debounce-input";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faX } from "@fortawesome/free-solid-svg-icons";

import OtherAvatar from "../../components/OtherAvatar";
import UserAvatar from "../../components/UserAvatar";
import DotLottie from "../../components/DotLottie";

import "./css/MissingStatus.css";

const ReminderDialog = ({ toggle, dataItem = { ItemId: null, ModuleId: null } }) => {
    const {
        data = [],
        isLoading,
        isFetching,
    } = useGetReminderCommentsQuery(
        { itemId: dataItem.ItemId, moduleId: dataItem.ModuleId },
        { skip: !dataItem.ItemId || !dataItem.ModuleId },
    );
    const loading = isLoading || isFetching;

    const { accessTokenPayload = { userName: "", userId: null } } = useSessionContext();
    const { userName = "", userId = null } = accessTokenPayload;

    const [text, setText] = useState("");

    const [selectedReminder, setSelectedReminder] = useState(null);

    const selectedReminderId = selectedReminder ?? data[0]?.reminderId ?? null;
    const selectedData = data.find((d) => d.reminderId === selectedReminderId) || null;

    const handleClose = () => {
        toggle();
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const newComment = {
                moduleId: dataItem.ScheduleId,
                itemId: dataItem.PropertyId,
                reminderId: dataItem.ReminderId,
                Comment: text,
            };
        } catch (error) {
            console.log(error);
        }
    };

    const isValidDate = (date) => {
        if (!date || isNaN(date.getTime())) {
            return false; // Ensure it's a valid date object
        }
        const year = date.getFullYear();
        return year >= 1000 && year <= 9999; // Ensure the year has 4 digits
    };

    return (
        <Dialog
            title={"Reminders and Comments"}
            onClose={handleClose}
            width={"65vw"}
            height={"80vh"}
            className="missing-status-cell"
        >
            <Container fluid className="d-flex flex-row mt-5">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center flex-column h-50">
                        <DotLottie
                            src="https://asm-static-files.s3.amazonaws.com/colorful-loading-spinner.lottie"
                            autoplay
                            style={{ width: 125, height: 125 }}
                            loop={true}
                        />
                    </div>
                ) : (
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            display: "flex", // use flex to shrink-wrap to children
                            width: "fit-content", // ensures ul only as wide as its li children
                            borderRight: "1px solid #ddd",
                            minWidth: "25%",
                        }}
                    >
                        {data.map((d, idx) => {
                            const defaultComment = d.comments[0] ?? null;
                            return (
                                <li
                                    key={idx}
                                    style={{
                                        display: "inline-block",
                                        marginRight: 8,
                                        background: selectedReminderId === d.reminderId ? "#e6f0fa" : "transparent",
                                        borderRadius: 6,
                                        cursor: "pointer",
                                        transition: "background 0.2s",
                                        width: "100%",
                                    }}
                                    onClick={() => setSelectedReminder(d.reminderId)}
                                    className="p-1"
                                >
                                    <Row className="mb-1" style={{ fontSize: "10px" }}>
                                        <Col>
                                            <div>{defaultComment.name}</div>
                                        </Col>
                                        <Col className={"text-end"}>
                                            {defaultComment.commentDate.toLocaleString("en-US", {
                                                year: "numeric",
                                                month: "numeric",
                                                day: "numeric",
                                                hour: "numeric",
                                                minute: "numeric",
                                            })}
                                        </Col>
                                    </Row>
                                    <Row className="align-items-center">
                                        <Col lg={2}>
                                            <UserAvatar name={defaultComment.name} className="user-avatar-small" />
                                        </Col>
                                        <Col>
                                            <div style={{ fontSize: "12px", wordBreak: "break-word" }} className="my-1">
                                                {defaultComment.comment}
                                            </div>
                                        </Col>
                                    </Row>
                                </li>
                            );
                        })}
                    </ul>
                )}
                <Container>{selectedReminderId && selectedData.reminderId}</Container>
            </Container>
        </Dialog>
    );
};

export default ReminderDialog;
